<div class="ziro-admin-page-content">
  @if (isLoading) {
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  } @else {
    <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;dial_plan_management.list.description' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>

      <ziro-datatable
        [class]="'ziro-card'"
        [dataAutomation]="tableDataAutomation"
        [columns]="columns"
        [rowDataSource]="data"
        [uniqueRowIdentifier]="null"
        [showCustomAlert]="true"
        [setColumnWidths]="false"
      >
        <div alert-content [innerHtml]="'tkey;dialplanmanagement.admin.group_list.no_results' | escapeHtml"></div>
      </ziro-datatable>
    </div>
  }
</div>

<ziro-bottom-nav></ziro-bottom-nav>
